import PageDataLoader from '../../../lib/page-data/loader';
import PageKey from '../../../lib/page-data/key';
import {
  TEAM_FIXTURES_PAGE_REQUEST,
  TEAM_FIXTURES_PAGE_RECEIVE,
  TEAM_FIXTURES_PAGE_FAILURE,
  PAGE_DATA_LOAD,
  SELECT_SEASON,
} from '../../action-types';

export const fetchFixturesPageData = (clubId, teamId, seasonId, request) => async (dispatch) => {
  try {
    dispatch({ type: SELECT_SEASON, payload: seasonId });
    dispatch({ type: TEAM_FIXTURES_PAGE_REQUEST, payload: { clubId, teamId, seasonId } });
    const pageKey = new PageKey(clubId, 'matches', { teamId, seasonId });
    const pageData = await PageDataLoader.getPageData(pageKey, request);
    const { competitions, matchFixtures } = pageData.data;
    dispatch({
      type: TEAM_FIXTURES_PAGE_RECEIVE,
      payload: { clubId, teamId, seasonId, competitions, matchFixtures },
    });
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
    return {};
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }

    dispatch({
      type: TEAM_FIXTURES_PAGE_FAILURE,
      payload: { clubId, teamId, statusCode, error },
    });
    return { error };
  }
};
